export default "__VITE_ASSET__CQOsxyZA__"